import React from 'react';
import { Box } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';
import { DEFAULT_HOTEL_IMAGE } from '@shared/utils/constants';
import { TILE_THUMBNAIL_WIDTH, TILE_THUMBNAIL_BORDER_RADIUS } from '../HotelTile.constants';
import type { ThumbnailProps } from '../HotelTile.types';

export const Thumbnail: React.FC<ThumbnailProps> = React.memo(({ src, alt }) => (
  <Box
    width={pxToRem(TILE_THUMBNAIL_WIDTH)}
    minWidth={pxToRem(TILE_THUMBNAIL_WIDTH)}
    alignSelf="stretch"
    borderTopLeftRadius={pxToRem(TILE_THUMBNAIL_BORDER_RADIUS)}
    borderBottomLeftRadius={pxToRem(TILE_THUMBNAIL_BORDER_RADIUS)}
    borderTopRightRadius={0}
    borderBottomRightRadius={0}
    backgroundColor="mono2"
    overflow="hidden"
    position="relative"
  >
    <Box
      as="img"
      src={src || DEFAULT_HOTEL_IMAGE}
      alt={alt || ''}
      position="absolute"
      top={0}
      left={0}
      width="100%"
      height="100%"
      objectFit="cover"
      display="block"
    />
  </Box>
));

Thumbnail.displayName = 'HotelTile.Thumbnail';
